export const VEHICLE_TYPES = [
  'Tır Tenteli Kayar Perde',
  'Tenteli',
  'Kayar Perde',
  'Frigo',
  'Kapalı Kasa',
  'Açık Kasa',
  'Lowbed',
  'Tanker',
  'Silobas',
  'Damper',
] as const;

export type VehicleType = (typeof VEHICLE_TYPES)[number];

export const normalizeVehicleType = (value?: string): string => {
  const raw = String(value || '').trim();
  if (!raw) return '';
  const lower = raw.toLocaleLowerCase('tr-TR');
  const match = VEHICLE_TYPES.find((item) => item.toLocaleLowerCase('tr-TR') === lower);
  if (match) return match;
  if (lower.includes('tir') && lower.includes('kapali') && lower.includes('dorse')) return 'Kapalı Kasa';
  if (lower.includes('kapali')) return 'Kapalı Kasa';
  if (lower.includes('perde')) return 'Kayar Perde';
  if (lower.includes('frigo')) return 'Frigo';
  if (lower.includes('tent')) return 'Tenteli';
  if (lower.includes('acik')) return 'Açık Kasa';
  if (lower.includes('lowbed')) return 'Lowbed';
  if (lower.includes('tanker')) return 'Tanker';
  return raw;
};

export const parseVehicleTypes = (value?: string): string[] => {
  if (!value) return [];
  return value
    .split(/[,;/\n]+/)
    .map((s) => s.trim())
    .filter(Boolean);
};

export const formatVehicleTypes = (types: string[]): string => {
  return [...new Set(types)].join(', ');
};
